import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type OttopilotGeographicNodesWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.ottopilotGeographicNodes> & {
    // Capability-specific UDO bindings, such as dynamically created templates, belong here.
};

export const ottopilotGeographicNodesWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({}),
}) satisfies zod.ZodType<OttopilotGeographicNodesWorkspaceCapabilityUdoBindings>;
